import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '@ui/components/Button/Button';
import { useAuth } from '@breath-lab/state';
import { ROUTES } from '../../../routes';
import { logEvent } from '../../../infra/firebase/analytics';
import { AnalyticsEvent } from '../../../domain/analytics';
import styles from './ClosingCTASection.module.css';

export default function ClosingCTASection() {
  const { t } = useTranslation('landing');
  const { openLoginModal, isAuthenticated } = useAuth();

  return (
    <section className={styles.section} data-theme="dark">
      <div className={styles.inner}>
        <h2 className={styles.heading}>{t('closingCta.heading')}</h2>
        <p className={styles.body}>{t('closingCta.body')}</p>
        {isAuthenticated ? (
          <Button as={Link} to={ROUTES.loggedInHome} onClick={() => logEvent(AnalyticsEvent.landingClosingCtaClick)}>
            {t('closingCta.ctaLoggedIn')}
          </Button>
        ) : (
          <Button onClick={() => { logEvent(AnalyticsEvent.landingClosingCtaClick); openLoginModal(); }}>
            {t('closingCta.cta')}
          </Button>
        )}
      </div>
    </section>
  );
}
